<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <!-- Filtre par catégorie amélioré -->
    <!-- Filtre par catégorie aligné à droite -->
    <div class="flex justify-end mb-4 mr-6">
      <div class="flex flex-wrap items-center gap-2">
        <label class="text-sm font-medium text-gray-700">Category :</label>

        <vs-select v-model="selectedCategory" class="vs-select--category" placeholder="All Categories"
          :clearable="false">
          <vs-select-item v-for="cat in uniqueCategories" :key="cat" :value="cat" :text="cat" />
        </vs-select>

        <vs-button v-if="selectedCategory" color="danger" class="ml-1 flex items-center justify-center"
          @click="selectedCategory = null">
          ✕
        </vs-button>

      </div>
    </div>

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="filteredProducts">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <div
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        <vs-button color="success" class="ml-2 mb-4 flex items-center" @click="exportExcel">
          <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4 mr-2" />
          Export Excel (Active)
        </vs-button>
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage
              * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item v-for="n in [5, 10, 20, 50, 100]" :key="n" @click="itemsPerPage = n">
              <span>{{ n }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="id">#Internal ID</vs-th>
        <vs-th sort-key="categoryName">Category</vs-th>
        <vs-th sort-key="shapeName">Shape</vs-th>
        <vs-th sort-key="name_en">Name EN</vs-th>
        <vs-th sort-key="length">Length (m)</vs-th>
        <vs-th sort-key="rollerlength">Roller Length (cm)</vs-th>
        <vs-th sort-key="diameter">Diameter (cm)</vs-th>
        <vs-th sort-key="perimeter_avg">Perimeter avg. (cm)</vs-th>
        <vs-th sort-key="spacing_avg">Spacing avg. (cm)</vs-th>
        <vs-th sort-key="height">Height (cm)</vs-th>
        <vs-th sort-key="width">Width (cm)</vs-th>
        <vs-th sort-key="volume">Volume (m3)</vs-th>
        <vs-th sort-key="alert_min">Minimum Stock Alert</vs-th>
        <vs-th sort-key="uomName">Uom</vs-th>
        <vs-th sort-key="external_supplier">Externally?</vs-th>
        <vs-th sort-key="isactive">Active</vs-th>
        <vs-th sort-key="isvisibleincombobox">In combobox</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr v-for="(tr, indextr) in data" :key="indextr" :data="tr">
            <vs-td>{{ tr.id }}</vs-td>
            <vs-td><vs-chip :color="getActiveColors(tr.categoryName)">{{ tr.categoryName }}</vs-chip></vs-td>
            <vs-td>{{ tr.shapeName }}</vs-td>
            <vs-td class="font-medium truncate">{{ tr.name_en }}</vs-td>
            <vs-td>{{ tr.length ? tr.length / 100 : null }}</vs-td>
            <vs-td>{{ tr.rollerlength }}</vs-td>
            <vs-td>{{ tr.diameter }}</vs-td>
            <vs-td>{{ tr.perimeter_avg }}</vs-td>
            <vs-td>{{ tr.spacing_avg }}</vs-td>
            <vs-td>{{ tr.height }}</vs-td>
            <vs-td>{{ tr.width }}</vs-td>
            <vs-td>{{ tr.volume ? parseFloat(tr.volume).toFixed(4) : 'n/a' }}</vs-td>
            <vs-td>{{ tr.alert_min }}</vs-td>
            <vs-td>{{ tr.uomName }}</vs-td>
            <vs-td><vs-chip>{{ tr.external_supplier }}</vs-chip></vs-td>
            <vs-td><vs-chip :color="getActiveColors(tr.isactive)">{{ tr.isactive }}</vs-chip></vs-td>
            <vs-td>
              <vs-chip v-if="tr.isvisibleincombobox" color="success">
                <feather-icon icon="CheckIcon" svgClasses="w-4 h-4 mr-1" /> visible
              </vs-chip>
              <vs-button v-else-if="![-1, 1, 3, 4, 5, 6].includes(tr.id)"
                color="warning" type="border" size="small" icon-pack="feather" icon="icon-eye-off"
                @click.stop="confirmEnableInCombobox(tr)">
                Enable
              </vs-button>
              <vs-chip v-else color="dark">hidden</vs-chip>
            </vs-td>
            <vs-td>
              <feather-icon v-if="![-1, 1, 3, 4, 5, 6].includes(tr.id)" icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import moduleDataListProduct from '@/store/products/product/moduleDataList.js'
import * as XLSX from 'xlsx'

export default {
  components: {
    DataViewSidebar
  },
  data() {
    return {
      selectedCategory: null,
      itemsPerPage: 5,
      addNewDataSidebar: false,
      sidebarData: {},
      isMounted: false,
      visibleProductIds: []
    }
  },
  computed: {
    products() {
      return this.$store.state.dataListProduct.products
    },
    flatProducts() {
      const visibleSet = new Set(this.visibleProductIds)
      return this.products.map(p => ({
        ...p,
        categoryName: p.productcategory && p.productcategory.name_en || '',
        shapeName: p.productcategory && p.productcategory.productcategoryshape && p.productcategory.productcategoryshape.name_en || '',
        uomName: p.uomsreference && p.uomsreference.name_en || '',
        isvisibleincombobox: visibleSet.has(p.id)
      }))
    },
    filteredProducts() {
      return this.flatProducts.filter(p =>
        !this.selectedCategory || p.categoryName === this.selectedCategory
      )
    },
    uniqueCategories() {
      return [...new Set(this.flatProducts.map(p => p.categoryName).filter(Boolean))].sort();
    },
    currentPage() {
      return this.isMounted ? this.$refs.table.currentx : 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
    }
  },
  methods: {
    exportExcel() {
      if (!this.filteredProducts || this.filteredProducts.length === 0) {
        this.$vs.notify({
          title: 'Error',
          text: 'No data to export.',
          color: 'warning',
          position: 'top-right'
        })
        return
      }

      // Filtrer uniquement les produits actifs
      const activeProducts = this.filteredProducts.filter(p => p.isactive === true)

      if (activeProducts.length === 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'No active products to export.',
          color: 'warning',
          position: 'top-right'
        })
        return
      }

      const data = activeProducts.map(p => ({
        ID: p.id,
        Category: p.categoryName,
        Shape: p.shapeName,
        Name_EN: p.name_en,
        Length_m: p.length ? (p.length / 100).toFixed(2) : '',
        Roller_cm: p.rollerlength,
        Diameter_cm: p.diameter,
        Perimeter_avg_cm: p.perimeter_avg,
        Spacing_avg_cm: p.spacing_avg,
        Height_cm: p.height,
        Width_cm: p.width,
        Volume_m3: p.volume ? parseFloat(p.volume).toFixed(4) : '',
        Alert_min: p.alert_min,
        UOM: p.uomName,
        External: p.external_supplier,
        Active: p.isactive === true ? 'Yes' : 'No'
      }))

      const worksheet = XLSX.utils.json_to_sheet(data)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Products')

      const fileName = `products_active_export_${new Date().toISOString().split('T')[0]}.xlsx`
      XLSX.writeFile(workbook, fileName)

      this.$vs.notify({
        title: 'Success',
        text: `Excel export successful. ${activeProducts.length} active product${activeProducts.length > 1 ? 's' : ''} exported.`,
        color: 'success',
        position: 'top-right'
      })
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    confirmEnableInCombobox(product) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Force visibility',
        text: `Make "${product.name_en}" (#${product.id}) appear in product comboboxes?`,
        accept: () => this.enableInCombobox(product)
      })
    },
    enableInCombobox(product) {
      this.$http.post(`/product/combobox/enable/${product.id}`)
        .then(() => {
          if (!this.visibleProductIds.includes(product.id)) {
            this.visibleProductIds = [...this.visibleProductIds, product.id]
          }
          this.$vs.notify({
            title: 'Done',
            text: `"${product.name_en}" is now visible in comboboxes.`,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch(err => {
          this.$vs.notify({
            title: 'Error',
            text: (err.response && err.response.data && err.response.data.message) || err.message || 'Request failed.',
            color: 'danger',
            position: 'top-right'
          })
        })
    },
    fetchVisibleProductIds() {
      this.$http.get('/product/combobox/visible-ids')
        .then(response => {
          this.visibleProductIds = Array.isArray(response.data) ? response.data : []
        })
        .catch(() => {
          this.visibleProductIds = []
        })
    },
    editData(data) {
      if (data.name_en === "Groupage") {
        this.$vs.notify({
          title: 'Please contact your administrator.',
          text: `Modification of this product may cause malfunctions.<br><b>Here is the current translation</b><br/>EN: ${data.name_en}<br>FR: ${data.name_fr}<br>RO: ${data.name_ro}<br>ES: ${data.name_es}<br>DE: ${data.name_de}<br>NL: ${data.name_nl}`,
          iconPack: 'feather',
          icon: 'icon-alert-triangle',
          color: 'danger',
          position: 'top-center',
          time: 10000
        })
      } else {
        this.sidebarData = data
        this.toggleDataSidebar(true)
      }
    },
    getActiveColors(status) {
      if (status === true) return 'primary'
      if (status === false) return 'danger'
      return 'black'
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
    }
  },
  created() {
    if (!moduleDataListProduct.isRegistered) {
      this.$store.registerModule('dataListProduct', moduleDataListProduct)
      moduleDataListProduct.isRegistered = true
    }
    this.$store.dispatch('dataListProduct/fetchDataListItems')
    this.fetchVisibleProductIds()
  },
  mounted() {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
.vs-select--category {
  min-width: 220px;
  max-width: 280px;

  .vs__dropdown-toggle {
    padding: 0.5rem 1rem !important;
    font-size: 0.95rem;
  }

  .vs__selected {
    font-size: 0.9rem;
  }
}

.vs-button.ml-1 {
  height: 32px;
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

#data-list-list-view {
  .vs-con-table {
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
